<script setup>
import { storeToRefs } from 'pinia'
import { usePortalsStore } from '@/stores/portals'
import { useUserStore } from '@/stores/user'
import CustomTabs from '@/components/CustomTabs.vue'
import CustomTab from '@/components/CustomTab.vue'
import TimeWindowsForm from '@/components/policies/TimeWindowsForm.vue'
import ReturnReasonsForm from '@/components/policies/ReturnReasonsForm.vue'
import PersonalizationForm from '@/components/policies/PersonalizationForm.vue'

const { selectedPortal } = storeToRefs(usePortalsStore())
const { canEditPersonalizationSection } = storeToRefs(useUserStore())
</script>

<template>
  <CustomTabs>
    <CustomTab
      title="Time Windows"
      :draft="selectedPortal.fields.policies.timeWindows.hasChanges"
      :error="selectedPortal.fields.policies.timeWindows.hasErrors"
    >
      <TimeWindowsForm />
    </CustomTab>
    <CustomTab
      title="Return Reasons"
      :draft="selectedPortal.fields.policies.$returnReasons.hasChanges"
      :error="selectedPortal.fields.policies.$returnReasons.hasErrors"
    >
      <ReturnReasonsForm 
        :disabled="!selectedPortal.fields.policies.$returnReasons.editable"
      />
    </CustomTab>
    <CustomTab
      v-if="canEditPersonalizationSection"
      title="Personalization"
      :draft="selectedPortal.fields.policies.personalization.hasChanges"
      :error="selectedPortal.fields.policies.personalization.hasErrors"
    >
      <PersonalizationForm />
    </CustomTab>
  </CustomTabs>
</template>
